import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/satisfaction.png'


const _hoisted_1 = { class: "card bg-primary border-0 rounded-3 position-relative mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_5 = { style: {"margin-bottom":"-16px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-0 text-white" }, "Customer Satisfaction", -1)),
        _createElementVNode("select", {
          class: "form-select month-select form-control p-0 h-auto border-0 w-90 text-white bg-transparent",
          style: _normalizeStyle({
            backgroundPosition: 'right 0 center',
            backgroundImage: `url(${_ctx.image})`,
          }),
          "aria-label": "Default select example"
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("option", {
            class: "text-secondary",
            selected: ""
          }, "Last Month", -1),
          _createElementVNode("option", {
            class: "text-secondary",
            value: "1"
          }, "Last Year", -1)
        ]), 4)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "donut",
                height: "145",
                options: _ctx.customerSatisfaction,
                series: _ctx.satisfaction
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("img", {
          src: _imports_0,
          alt: "satisfaction"
        }, null, -1))
      ])
    ])
  ]))
}